// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3-gLW","selects":"Documents_selects__2ba9s"};